import useShortcuts from '@/mixins/useShortcuts'
import { ShortcutLayer } from '@/utils/shortcut'

/**
 * 弹窗快捷键薄封装：统一 dialog 层注册/注销，避免各组件重复样板代码。
 * 与 useShortcuts 一起 mixin 使用。
 *
 * 扫码契约（中心模式）：
 * - bindDialogShortcuts 默认 exclusive，打开后 widget 层 FastAdd 仍常驻栈顶，但 getScanSink 会先认 dialog
 * - 弹窗内需要二次扫码（选品、SearchMore、AddGoods）→ options.onScan 必填
 * - 纯表单弹窗（改价、备注）→ 不传 onScan，扫码会被 dialog 挡住，避免误触主搜索框
 */
export default {
  mixins: [useShortcuts],

  methods: {
    /**
     * @param {Object} keys Mousetrap 键名 -> handler
     * @param {Object} [options]
     * @param {Function} [options.onScan]
     * @param {boolean} [options.enterInInput] 焦点在 INPUT/TEXTAREA 时仍走 enter handler（备注/单行确认框）
     * @param {boolean} [options.strictDigitBuffer]
     * @param {Function} [options.onDigitReplay]
     */
    bindDialogShortcuts(keys, options = {}) {
      this.bindShortcuts(keys, {
        layer: ShortcutLayer.DIALOG,
        exclusive: true,
        onScan: options.onScan || null,
        enterInInput: options.enterInInput,
        strictDigitBuffer: options.strictDigitBuffer,
        onDigitReplay: options.onDigitReplay || null,
      })
    },

    unbindDialogShortcuts() {
      this.unbindShortcuts()
    },
  },
}
